import { render, staticRenderFns } from "./TradepointPage.vue?vue&type=template&id=60c8f683&"
import script from "./TradepointPage.vue?vue&type=script&lang=js&"
export * from "./TradepointPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports